import { render, staticRenderFns } from "./FilterPlacementsForm.tmplacements.vue?vue&type=template&id=4b661f5a&scoped=true&lang=html&"
import script from "./FilterPlacementsForm.tmplacements.vue?vue&type=script&lang=js&"
export * from "./FilterPlacementsForm.tmplacements.vue?vue&type=script&lang=js&"
import style0 from "./FilterPlacementsForm.tmplacements.vue?vue&type=style&index=0&id=4b661f5a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b661f5a",
  null
  
)

export default component.exports